interface ISiteElementPriceInfo {
    price: number;
    quantity: number;
}

class SiteElementPrice
    extends QueryElement<HTMLElement> {

    
    constructor(element: HTMLElement, quantityPicker: ISiteElementQuantityPicker) {
        super(element);

        let prefix = this.query("span.prefix").first();
        let decimals = this.query("span.decimals").first();
        let values = JSON.parse(this.getAttr("data-values") ?? "{}");

        if (prefix == null || decimals == null)
            throw "Element(s) not found!";

        let priceValueArray : ISiteElementPriceInfo[] = [];
        for(let x in values)
        {
            priceValueArray.push({
                price: values[x],
                quantity: parseInt(x)
            });
        }

        priceValueArray = priceValueArray
            .sort(function(a, b) {
                return a.quantity - b.quantity;
            })
            .reverse();
        
        quantityPicker.valueEvent.on(async (a) => {
            for(var x of priceValueArray) {
                if (x.quantity <= a) {
                    prefix?.setHtml(Math.floor(x.price).toString());

                    // Calculate decimals:
                    var priceDecimals = (x.price % 1).toFixed(4).substring(2);
                    if (priceDecimals[3] == "0") {
                        priceDecimals = priceDecimals.slice(0, -1);

                        if (priceDecimals[2] == "0") {
                            priceDecimals = priceDecimals.slice(0, -1);
                        }
                    }
                    decimals?.setHtml(priceDecimals);

                    break;
                }
            }
        });
    }
}